module.exports = __webpack_public_path__ + "img/usdt.8a13fa46.svg";